import * as React from "react";
import { forwardRef, memo } from "react";
const SvgAx = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 17", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#0064AD", d: "M0 0h26v17H0z" }), /* @__PURE__ */ React.createElement("g", { fill: "#FFD300" }, /* @__PURE__ */ React.createElement("path", { d: "M8 0h5v17H8z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 6h26v5H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "#Da0e15" }, /* @__PURE__ */ React.createElement("path", { d: "M9.5 0h2v17H9.5z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 7.5h26v2H0z" })));
const ForwardRef = forwardRef(SvgAx);
const Memo = memo(ForwardRef);
export default Memo;
